export const page4 = {
  "name": "page4",
  "title": "Your Lifestyle",
  "elements": [
    {
      "type": "rating",
      "name": "peers_healthier",
      "title": "How much do you feel you peers are healthier than you? ",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": "Item 1",
          "text": "Not at all"
        },
        {
          "value": "Item 2",
          "text": "Slightly"
        },
        {
          "value": "Item 3",
          "text": "Moderately"
        },
        {
          "value": "Item 4",
          "text": "Significantly"
        },
        {
          "value": "Item 5",
          "text": "Extremely"
        }
      ]
    },
    {
      "type": "rating",
      "name": "medical_checkup",
      "title": "When did you do your last medical checkup?",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": "Item 1",
          "text": "Over 12 months ago"
        },
        {
          "value": "Item 2",
          "text": "6 moths"
        },
        {
          "value": "Item 3",
          "text": "3 months"
        },
        {
          "value": "Item 4",
          "text": "last month"
        }
      ]
    },
    {
      "type": "rating",
      "name": "body_rating",
      "title": "What rating would you give your body?",
      "isRequired": true,
      "rateType": "stars"
    }
  ]
};